import { Component, OnInit } from '@angular/core';
import { MenuItem } from '../../model/menu-item';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout-scope',
  templateUrl: './layout-scope.component.html',
  styleUrls: ['./layout-scope.component.css']
})
export class LayoutScopeComponent implements OnInit {
  _myMenu: Array<MenuItem>;

  constructor(private _router: Router) {
    this.createNavBarMenu();
  }

  ngOnInit() {
    if (this._router.url === '/') {
      this._router.navigate(['attendings', 'list']);
    }
  }

  createNavBarMenu() {
    const item = new MenuItem('Notificações', '/notifications', 'white chip tx-text-light', 'fa-bell');
    this._myMenu = new Array();
    this._myMenu.push(item);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/layout-scope/layout-scope.component.ts